import { Model } from 'modules/core/lib/mobx-rest'

import { CodeableType } from 'modules/payroll_integrations/lib/enums'

interface CodeAttributes {
  id: string
  code: string
  codeable_id: string
  codeable_type: CodeableType
  company_id: string
  forfait_jours: boolean
  integration: string
}

class Code extends Model<CodeAttributes> {
  static urlRoot() {
    return '/payroll_integrations/codes'
  }
}

export default Code
